module.exports = __webpack_public_path__ + "img/21372384000143.22c4f976.png";